import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { pdfStyles } from '../../..';
import { calculateNewSubtotalOfExistingDocUtility } from '../../../../config/utils/moneyCollectionUtils';
import { MoneyCollection } from '../../../../interfaces/moneyCollection.interface';

interface Props {
  doc: MoneyCollection;
  currency: string | null | undefined;
}

export const PdfMoneyCollectionValueSection = ({ doc, currency }: Props) => {
  const { t } = useTranslation();

  const calculateNewSubtotal = useCallback(() => {
    return calculateNewSubtotalOfExistingDocUtility(doc.paymentType, doc.currentSubtotal, doc.value).toFixed(2);
  }, [doc.paymentType, doc.currentSubtotal, doc.value]);

  return (
    <View style={{ paddingTop: 10 }}>
      <View style={styles.row}>
        <View style={styles.column}>
          <Text style={pdfStyles.smallTitle}>{t('PDF.OLD_SUBTOTAL')}</Text>
          <Text style={[pdfStyles.body1]}>
            {doc?.currentSubtotal} ({currency})
          </Text>
        </View>
        <View style={styles.columnCenter}>
          <Text style={pdfStyles.smallTitle}>{t('PDF.PRICE')}</Text>
          <Text style={[pdfStyles.body1]}>
            {doc.value} ({currency})
          </Text>
        </View>
        <View style={styles.columnEnd}>
          <Text style={pdfStyles.smallTitle}>{t('PDF.NEW_SUBTOTAL')}</Text>
          <Text style={[pdfStyles.body1]}>
            {calculateNewSubtotal()} ({currency})
          </Text>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  column: {
    flexDirection: 'column',
    width: '33%',
    alignItems: 'flex-start',
  },
  columnCenter: {
    flexDirection: 'column',
    width: '33%',
    alignItems: 'center',
  },
  columnEnd: {
    flexDirection: 'column',
    width: '33%',
    alignItems: 'flex-end',
  },
});
